export default {
    CANVASHOLDER: 'canvasHolder',
    CANVASITEM: 'canvasItem',
    CANVASCOLUMN: 'canvasColumn',
    NEWITEM: 'newItem',
    NEWHOLDER: 'newHolder'

}